import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Flex, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { IconForm } from "@domestika-dev/prudencio/dist/atoms/Icon";
import { Send } from "@domestika-dev/prudencio/dist/atoms/Icons";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";

export const ChatFooterSendButton = ({ disabled, onSendMessage }) => {
  return (
    <GridItem gridRow="2" gridColumn="8">
      <Flex width="100%" justifyContent="flex-end" alignItems="center">
        <Button size="small" action={onSendMessage} disabled={disabled}>
          <Text size="tiny" fontWeight="medium" color="coco">
            <FormattedMessage id="live_sessions.chat.footer.send_button" />
          </Text>
          <IconForm marginLeft={2}>
            <Send />
          </IconForm>
        </Button>
      </Flex>
    </GridItem>
  );
};

ChatFooterSendButton.propTypes = {
  disabled: PropTypes.bool,
  onSendMessage: PropTypes.func.isRequired,
};

ChatFooterSendButton.defaultProps = {
  disabled: false,
};

export default ChatFooterSendButton;
